import React, { useEffect, useState } from "react";
import DashboardCard from "../Component/DashboardCard";
import { useNavigate } from "react-router-dom";
import api from "../api/api"; // ✅ same API service

export default function Dashboard() {
  const navigate = useNavigate();

  const [data, setData] = useState({
    QCFinished: 0,
    QCFinishedQty: "0.00",
    WaitingForQC: 0,
    WaitingForQCQty: "0.00",
    WaitingForGrn: 0,
    WaitingForGrnQty: "0.00",
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const userName = sessionStorage.getItem("userName");
        const databaseKey = sessionStorage.getItem("databaseKey");

        if (!userName || !databaseKey) {
          console.error("❌ Missing userName or databaseKey in sessionStorage");
          setLoading(false);
          return;
        }

        console.log("📡 Fetching Dashboard Data:", { userName, databaseKey });

        const res = await api.GetQcDashBoardList_API(userName, databaseKey);

        console.log("✅ API Response:", res);

        // ✅ Adjust according to your JSON structure
        const result = res?.GetQcDashBoardList_APIjs || res;
        const table = result?.Table?.[0] || {};
        const table1 = result?.Table1?.[0] || {};
        const table2 = result?.Table2?.[0] || {};

        setData({
          QCFinished: table.QCFinished || 0,
          QCFinishedQty: table.QCFinishedQty || "0.00",
          WaitingForQC: table1.WaitingForQC || 0,
          WaitingForQCQty: table1.WaitingForQCQty || "0.00",
          WaitingForGrn: table2.WaitingForGrn || 0,
          WaitingForGrnQty: table2.WaitingForGrnQty || "0.00",
        });
      } catch (err) {
        console.error("❌ Dashboard API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-full mx-auto bg-white rounded-lg shadow-lg">
          <div className="flex justify-center items-center h-64">
            <div className="animate-pulse text-xl text-slate-600 font-semibold">🔄 Loading data...</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-full mx-auto bg-white rounded-lg shadow-lg">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-400 to-blue-500 text-white p-4 rounded-t-lg">
          <h1 className="text-xl font-bold text-center">Quality Control Dashboard</h1>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {/* ✅ QC Finished */}
            <DashboardCard
              title=""
              value={
                <div className="text-base space-y-1">
                  <div>QC Finished: {data.QCFinished}</div>
                  <div>Qty: {data.QCFinishedQty}</div>
                </div>
              }
              bgColor="bg-blue-500"
              onClick={() => navigate("/QcFinished")}
            />

            {/* ✅ Waiting For QC */}
            <DashboardCard
              title=""
              value={
                <div className="text-base space-y-1">
                  <div>Waiting For QC: {data.WaitingForQC}</div>
                  <div>Qty: {data.WaitingForQCQty}</div>
                </div>
              }
              bgColor="bg-green-500"
              onClick={() => navigate("/waitforqc")}
            />

            {/* ✅ GRN Pending */}
            <DashboardCard
              title=""
              value={
                <div className="text-base space-y-1">
                  <div>GRN Pending: {data.WaitingForGrn}</div>
                  <div>Qty: {data.WaitingForGrnQty}</div>
                </div>
              }
              bgColor="bg-orange-500"
              onClick={() => navigate("/GrnPending")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
